var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShip2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.2303 67.8854H67.3412C66.5183 67.8854 65.8457 67.2128 65.8457 66.3899V60.0929C65.8457 59.27 66.5183 58.5974 67.3412 58.5974H85.2303C86.0532 58.5974 86.7258 59.27 86.7258 60.0929V66.3899C86.7258 67.2128 86.0532 67.8854 85.2303 67.8854ZM67.9924 65.7387H84.5792V60.7369H67.9924V65.7387Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1897 71.5996H65.6387V73.7463H70.1897V71.5996Z",
    fill: "#00A3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5256 71.5996H73.9746V73.7463H78.5256V71.5996Z",
    fill: "#00A3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9338 71.5996H82.3828V73.7463H86.9338V71.5996Z",
    fill: "#00A3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1897 77.8175H65.6387V79.9642H70.1897V77.8175Z",
    fill: "#00A3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5256 77.8175H73.9746V79.9642H78.5256V77.8175Z",
    fill: "#00A3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7678 77.624H83.6211V86.3754H85.7678V77.624Z",
    fill: "#00A3FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1897 84.0361H65.6387V86.1828H70.1897V84.0361Z",
    fill: "#00A3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5256 84.0361H73.9746V86.1828H78.5256V84.0361Z",
    fill: "#00A3FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6453 68.0283H36.9941V70.175H61.6453V68.0283Z",
    fill: "#00A3FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4537 91.5563H63.1138C61.7113 91.5563 60.5664 90.4186 60.5664 89.0089V55.9499C60.5664 54.5474 61.7042 53.4025 63.1138 53.4025H89.4537C90.8562 53.4025 92.0011 54.5402 92.0011 55.9499V89.0089C92.0011 90.4186 90.8562 91.5563 89.4537 91.5563ZM63.1138 55.5563C62.892 55.5563 62.7131 55.7352 62.7131 55.957V89.0161C62.7131 89.2379 62.892 89.4168 63.1138 89.4168H89.4537C89.6755 89.4168 89.8544 89.2379 89.8544 89.0161V55.957C89.8544 55.7352 89.6755 55.5563 89.4537 55.5563H63.1138Z",
    fill: "#00A3FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1127 91.5563H28V28H68.78L81.4741 40.6941V54.483H79.3274V41.5814L67.8927 30.1467H30.1467V89.4097H63.1127V91.5563Z",
    fill: "#00A3FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4014 42.2111H67.2637V29.0734H69.4104V40.0644H80.4014V42.2111Z",
    fill: "#00A3FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3519 78.6619H36.9941V80.8086H53.3519V78.6619Z",
    fill: "#00A3FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9685 57.3524H44.8218V60.3864H46.9685V57.3524Z",
    fill: "#2DCDAF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9685 37.1163H44.8218V40.0716H46.9685V37.1163Z",
    fill: "#2DCDAF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4552 58.4257H44.3425C41.4731 58.4257 39.1403 56.1573 39.1403 53.3666H41.287C41.287 54.9695 42.6609 56.279 44.3425 56.279H47.4552C49.33 56.279 50.8613 54.8192 50.8613 53.0303C50.8613 52.1716 50.5106 51.3559 49.881 50.7477C49.2369 50.1251 48.3783 49.7817 47.4623 49.7817H44.3496C41.287 49.7817 38.7969 47.3631 38.7969 44.3863C38.7969 42.9409 39.3765 41.5813 40.4355 40.5581C41.4802 39.5491 42.8756 38.991 44.3496 38.991H47.4623C50.3318 38.991 52.6645 41.2593 52.6645 44.05H50.5178C50.5178 42.4471 49.1439 41.1377 47.4623 41.1377H44.3496C43.4337 41.1377 42.5751 41.4811 41.931 42.1037C41.2942 42.7191 40.9507 43.5276 40.9507 44.3863C40.9507 46.1752 42.482 47.635 44.3568 47.635H47.4695C48.9436 47.635 50.3318 48.1931 51.3836 49.2021C52.4427 50.2253 53.0223 51.5849 53.0223 53.0303C53.008 56.0071 50.5178 58.4257 47.4552 58.4257Z",
    fill: "#2DCDAF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 118,
    height: 118,
    rx: 31,
    stroke: "#09547E",
    strokeOpacity: 0.05,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip2);
export default __webpack_public_path__ + "static/media/ship2.377f6e706e7c831b692453a22e359aba.svg";
export { ForwardRef as ReactComponent };